import { ArrowLeft } from "lucide-react";
import { site } from "../content/site";

export const LegalPage = ({ page }) => {
  const content = site.legal[page];

  return (
    <main className="border-t border-gray-200 bg-white" data-testid={`${page}-page`}>
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <a
          href="/"
          className="inline-flex items-center gap-2 rounded-sm text-sm font-semibold text-brand transition-colors duration-200 hover:text-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to Home
        </a>

        <p className="mt-10 text-xs font-semibold uppercase tracking-[0.14em] text-brand">
          Last updated {site.legal.lastUpdated}
        </p>
        <h1 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          {content.title}
        </h1>
        <p className="mt-6 text-base leading-relaxed text-gray-600">{content.intro}</p>

        <div className="mt-12 space-y-10">
          {content.sections.map((section) => (
            <section key={section.heading} className="border-t border-gray-200 pt-6">
              <h2 className="font-heading text-xl font-bold text-gray-900">{section.heading}</h2>
              <div className="mt-3 space-y-3">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="text-sm leading-relaxed text-gray-600">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </section>
    </main>
  );
};
